import Echo from "laravel-echo";
import http from "@/services/http";

// Broadcasting is optional. Only instantiate Laravel Echo / Pusher when a
// Pusher app key is provided at build time. Without a key, pusher-js throws
// "You must pass your app key" on instantiation, which crashes the whole SPA
// (blank page). Exporting null lets consumers (e.g. the routeReloader plugin,
// which already guards on `Vue.Echo`) skip the real-time features gracefully.
let echo = null;

if (process.env.MIX_PUSHER_APP_KEY) {
  window.Pusher = require("pusher-js");

  echo = new Echo({
    broadcaster: "pusher",
    key: process.env.MIX_PUSHER_APP_KEY,
    wsHost: process.env.MIX_PUSHER_HOST,
    wsPort: process.env.MIX_PUSHER_PORT,
    wssPort: process.env.MIX_PUSHER_PORT,
    forceTLS: process.env.MIX_PUSHER_PORT === 443,
    encrypted: true,
    disableStats: true,
    enabledTransports: ["ws", "wss"],
    authorizer: channel => {
      return {
        authorize: (socketId, callback) => {
          http
            .post("/api/broadcasting/auth", {
              socket_id: socketId,
              channel_name: channel.name
            })
            .then(response => {
              callback(false, response.data);
            })
            .catch(error => {
              callback(true, error);
            });
        }
      };
    }
  });
}

export default echo;
